import React from 'react';
import './Destinations.css';

import { Heading, Destination } from '../../../components';
import { destinations } from '../../../constants';



const Destinations = () => { 
  return ( 

      <section className='destinations'>

        {/* Section heading */}
        <Heading title={'Our Destinations'} subTitle={'Explore Our Adventure Destinations'} />

        <div className='box-container'>
          {/* Loop through the destinations array and render each destination */}
          {destinations.map((destination) => (
            <Destination key={destination.id} destination={destination} />
          ))}
        </div>

      </section>
   
  )
}

export default Destinations;